var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAnyMatch = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M471.33,213.44q-1,32.46-11.72,56.8T432.09,311a111,111,0,0,1-38.74,24.82,125.75,125.75,0,0,1-45,8.34q-23,0-39.73-5A114.39,114.39,0,0,1,279,325.84,120.07,120.07,0,0,1,256.26,307q-9.81-10.49-18.65-21.46t-17-20.51a155.09,155.09,0,0,0-16.75-16.92,71.81,71.81,0,0,0-18.66-11.69,57.85,57.85,0,0,0-23-4.3q-16.26,0-27.52,6.9a56.37,56.37,0,0,0-18.42,18.29A79.27,79.27,0,0,0,106,283.46a151.9,151.9,0,0,0-3.11,31.37q0,8.57-8.1,11.17T71.5,328.61A100.8,100.8,0,0,1,56,327.66a37,37,0,0,1-9.54-2.61,8.91,8.91,0,0,1-4.75-4.53,15.93,15.93,0,0,1-1.18-6.18V301.49q0-32.83,9.09-57.81T75,201.82a104.41,104.41,0,0,1,39-25.45,139.33,139.33,0,0,1,49.52-8.57q22.47,0,39.47,5a120.63,120.63,0,0,1,29.91,13.11,125.89,125.89,0,0,1,23,18.36,258.27,258.27,0,0,1,18.66,21.22q8.61,11,16.51,20.51a137.49,137.49,0,0,0,16.5,16.92,71.77,71.77,0,0,0,18.66,11.68q10.05,4.29,23.45,4.29,15.78,0,27-6.21a50.75,50.75,0,0,0,18.43-17.44,81.07,81.07,0,0,0,10.52-26.49A157.14,157.14,0,0,0,409,195.32q0-7.63,7.86-10.27t23.08-2.63a137.79,137.79,0,0,1,15.23.71,30.56,30.56,0,0,1,10,2.64,11.08,11.08,0,0,1,5.23,4.76,12.84,12.84,0,0,1,1,7.16Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAnyMatch);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/AnyMatch.0f7b609a3c0aa3c85f5556e365738f72.svg";